import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

// 📱 NÚMERO DE WHATSAPP PARA ACCESO DIRECTO
const WHATSAPP_NUMBER = '573001234567'; // Reemplaza con tu número real

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-grid">
        
        {/* Columna 1: Branding */}
        <div>
          <Link to="/">
            <img 
              src="/uploads/logo.png" 
              alt="NeoClic" 
              className="footer-logo"
            />
          </Link>
          <p className="footer-brand-desc">
            Ecosistema de accesorios y periféricos de alta gama. Optimizamos tu espacio digital con tecnología que te conecta.
          </p>
        </div>

        {/* Columna 2: Mapa del Sitio */}
        <div>
          <h4 className="footer-col-title">EXPLORAR</h4>
          <div className="footer-links-container">
            <Link to="/" className="footer-link">Inicio</Link>
            <Link to="/catalogo" className="footer-link">Catálogo de Productos</Link>
            <Link to="/perfil" className="footer-link">Perfil de Usuario</Link>
          </div>
        </div>

        {/* Columna 3: Atención al Cliente */}
        <div>
          <h4 className="footer-col-title">SOPORTE</h4>
          <div className="footer-links-container">
            <Link to="/envios" className="footer-link">Políticas de Envío</Link>
            <Link to="/garantias" className="footer-link">Garantías y Devoluciones</Link>
            <Link to="/contacto" className="footer-link">PQRS y Contacto</Link>
          </div>
        </div>

        {/* 🌐 Columna 4: REDES SOCIALES */}
        <div>
          <h4 className="footer-col-title">SÍGUENOS</h4>
          <p className="footer-social-desc">Conéctate con nuestra comunidad digital:</p>
          <div className="footer-social-icons">
            
            {/* Instagram */}
            <a 
              href="https://instagram.com/neoclic" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="social-icon-btn instagram"
              aria-label="Instagram"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
              </svg>
            </a>

            {/* Facebook */}
            <a 
              href="https://facebook.com/neoclic" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="social-icon-btn facebook"
              aria-label="Facebook"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
              </svg>
            </a>

            {/* TikTok */}
            <a 
              href="https://tiktok.com/@neoclic" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="social-icon-btn tiktok"
              aria-label="TikTok"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 1 1-5.2-1.74 2.89 2.89 0 0 1 2.31-2.86V7.58a6.34 6.34 0 0 0-1 .08 6.34 6.34 0 1 0 7.34 6.25V8.56a8.27 8.27 0 0 0 4.77 1.51v-3.38a4.85 4.85 0 0 1-1-.02z"/>
              </svg>
            </a>

            {/* WhatsApp */}
            <a 
              href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent('¡Hola NeoClic! Quisiera recibir información.')}`}
              target="_blank" 
              rel="noopener noreferrer" 
              className="social-icon-btn whatsapp"
              aria-label="WhatsApp"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/>
              </svg>
            </a>

          </div>
        </div>

      </div>

      {/* Copyright Line */}
      <div className="footer-copyright">
        &copy; 2026 NEOCLIC. TODOS LOS DERECHOS RESERVADOS.
      </div>
    </footer>
  );
};

export default Footer;